import React, { useState } from 'react';
import styled from 'styled-components';
import { Flex, Box, Text } from 'rebass/styled-components';
import { FaArrowDown, FaArrowUp } from 'react-icons/fa';

const FAQSection = styled.section`
  max-width: 650px;
  margin: 0px auto;
  padding: 0 20px;
  font-family: 'Sk-Modernist-Regular', sans-serif;
  color: #1a232e;
`;

const MainHeading = styled.h2`
  color: #ff4f00; /* Orange main heading */
  font-weight: 400;
  font-style: Regular;
  font-size: 32px;
  leading-trim: NONE;
  line-height: 44px;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  text-align: center;
  margin-bottom: 20px; /* Space before accordions */
`;

const AccordionContainer = styled(Box)`
  border-top: 1px solid #ffe8e0; /* Faint orange border above first item */
`;

const AccordionItem = styled(Box)`
  border-bottom: 1px solid #e8480066; /* Faint orange border between items */
`;

const AccordionHeader = styled(Flex)`
  justify-content: space-between;
  align-items: center;
  padding: 24px 0;
  cursor: pointer;
  user-select: none;
  transition: background-color 0.2s;
`;

const QuestionText = styled.h3`
  font-weight: 500;
  font-style: Medium;
  font-size: 20px;
  leading-trim: NONE;
  line-height: 32px;
  letter-spacing: 0%;
  margin: 0;
  color: #252422; /* Navy/black question text */
`;

const IconWrapper = styled(Flex)`
  color: #e8480066; /* Primary Orange icon color */
  margin-left: 20px;
`;

// Mobile specific dropdown container
const AnswerContent = styled(Box)<{ isOpen: boolean }>`
  max-height: ${(props) => (props.isOpen ? '500px' : '0')}; /* Control height for animation */
  overflow: hidden;
  transition: max-height 0.3s ease-in-out, padding 0.3s ease-in-out;
  padding: ${(props) => (props.isOpen ? '0 0 24px 0' : '0')}; /* Only pad when open */
`;

const AnswerText = styled(Text)`
  font-weight: 400;
  font-style: Regular;
  font-size: 16px;
  leading-trim: NONE;
  line-height: 24px;
  letter-spacing: 0%;
  color: #252422;
`;

const faqData = [
  {
    question: 'Is it free to use the My Pharmacy?',
    answer:
      'ConX is a digital care platform designed for pharmacies and healthcare providers. It streamlines bookings, consultations, patient records, compliance, and reporting — all in one easy-to-use, NHS-connected system.',
  },
  {
    question: 'Can I sign in using my NHS login?',
    answer:
      'ConX supports independent pharmacies, multi-branch groups, GP surgeries, private clinics, physiotherapy teams, virtual wards, and population health services. If you deliver patient care, ConX fits your workflow.',
  },
  {
    question: 'Can I change the medicines on my list?',
    answer:
      'Absolutely. ConX was built with independents in mind — easy setup, no technical jargon, and scalable as you grow.',
  },
  {
    question: 'How do I know if I qualify for free NHS prescriptions?',
    answer:
      'ConX uses enterprise-grade encryption and UK-based cloud hosting. Only authorised staff have access via role-based permissions, ensuring total data protection.',
  },
  {
    question: 'Will I receive updates on my order?',
    answer:
      'Setup is quick and guided — typically just a few days. Our team helps configure your services, staff roles, and data connections so you’re ready to go live smoothly.',
  },
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggleAccordion = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div style={{ background: '#FFEDE6', padding: '100px 0' }}>
      <FAQSection>
        {/* 1. orange 'Frequently asked questions' heading */}
        <MainHeading>Frequently asked questions</MainHeading>

        {/* 2. Accordion Container */}
        <AccordionContainer>
          {faqData.map((item, index) => (
            <AccordionItem key={index}>
              {/* Header: Clickable region with question and icon */}
              <AccordionHeader onClick={() => toggleAccordion(index)}>
                <QuestionText>{item.question}</QuestionText>
                <IconWrapper>{openIndex === index ? <FaArrowUp size={14} /> : <FaArrowDown size={14} />}</IconWrapper>
              </AccordionHeader>

              {/* Content: Visible only when open */}
              <AnswerContent isOpen={openIndex === index}>
                <AnswerText>{item.answer}</AnswerText>
              </AnswerContent>
            </AccordionItem>
          ))}
        </AccordionContainer>
      </FAQSection>
    </div>
  );
};

export default FAQ;
